import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/app/wiki/page.tsx");
